import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

import { View } from '../Base';
import palette from '../styles/palette';

const useStyles = makeStyles(({ typography }) => {
  const { pxToRem } = typography;
  return {
    container: {
      padding: pxToRem(2),
      backgroundColor: '#fff',
      borderRadius: pxToRem(4),
      boxShadow: `0px 4px 4px ${palette.typography.black.disabled}`,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
    },
    anchor: {
      '&::after': {
        content: '""',
        position: 'absolute',
        top: '100%',
        left: '50%',
        marginLeft: pxToRem(-5),
        borderLeft: '5px solid transparent',
        borderRight: '5px solid transparent',
        borderTop: '13px solid #fff',
      },
      '&::before': {
        content: '""',
        position: 'absolute',
        top: '100%',
        left: '50%',
        marginLeft: pxToRem(-5),
        boxShadow: `5px 5px 3px ${palette.typography.black.disabled}`,
        height: pxToRem(3),
        width: pxToRem(13),
        transform: 'rotate(75deg)',
        zIndex: -1,
      },
    },
  };
});

const MarkerContainer = ({
  children,
  className,
  withAnchor = true,
  ...props
}) => {
  const styles = useStyles();
  return (
    <View
      className={clsx(styles.container, className, withAnchor && styles.anchor)}
      {...props}
    >
      {children}
    </View>
  );
};

export default memo(MarkerContainer);
